import { infoColor } from '@zego/theme';

import generateTintTheme from './generateTintTheme';

export default generateTintTheme(infoColor(5));
